/* react-toastify CSS classes */
export var ToastClassNames = {
  ANIMATE_ANIMATED: '.animate__animated',
  CONTAINER: '.Toastify__toast-container',
  CUSTOM_TRANSITION: '.Toastify__custom-transition',
  CUSTOM_TRANSITION_ENTER: '.Toastify__custom-transition--enter',
  CUSTOM_TRANSITION_EXIT: '.Toastify__custom-transition--exit',
  ICON: '.Toastify__toast-icon',
  TOAST: '.Toastify__toast',
  TOAST_BODY: '.Toastify__toast-body',
  TOAST_DEFAULT: '.Toastify__toast--default',
  TOAST_ERROR: '.Toastify__toast--error',
  TOAST_INFO: '.Toastify__toast--info',
  TOAST_SUCCESS: '.Toastify__toast--success',
  TOAST_WARNING: '.Toastify__toast--warning'
};